<template>


<Estado></Estado>
</template>



<script>

import Estado from '@/components/Estado.vue'

export default {
  name: 'Tracking',
  components: {
    Estado
  }
}
</script> 